import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Card, Button } from "react-bootstrap";
import ReactTost from "../../ReactTost";
import { useParams, Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import BtnLoader from "../../BtnLoader";
import DataTable from "react-data-table-component";
import { useForm } from "react-hook-form";

const EditClient = () => {
  const { id } = useParams();
  const user = localStorage.getItem("id");
  const [msg, setMsg] = useState();
  const [, setMonthList] = useState([]);
  const [planId, setPlanId] = useState("");
  const { t } = useTranslation();
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const [activePlan, setActivePlan] = useState([]);
  const [date, setDate] = useState();
  const [sellerId, setSellerId] = useState();
  const [paymentId, setPaymentId] = useState(false);
  const [paymentDate, setPaymentDate] = useState();
  // const [confirm_password, ] = useState();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [website, setWebsite] = useState("");
  const [plan, setPlan] = useState();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [, setLoading] = useState(false);
  const [loaderDate, setLoaderDate] = useState(false);
  const [loaderUpdate, setLoaderUpdate] = useState(false);

  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [payHistory, setPayHistory] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [data, setData] = useState([]);

  function UpdateUser() {
    setLoaderUpdate(true);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/user/${id}`,
        {
          name,
          email,
          phone,
          company,
          website,
        },
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setLoaderUpdate(false);
        setType(t("Success"));
        setMessage(t("Profile updated."));
        setShowAlert(true);
      })
      .catch((error) => {
        setLoaderUpdate(false);
        setType("Danger");
        setMessage(
          error.response.data.message
            ? error.response.data.message
            : t("Something went to wrong.")
        );
        setShowAlert(true);
      });
  }


  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_URL}/${API_VERSION}/user/${id}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setName(response.data.name);
        setEmail(response.data.email);
        setPhone(response.data.phone);
        setCompany(response.data.company);
        setWebsite(response.data.website);
        setDate(response.data.expireDateByAdmin);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went to wrong."));
        setShowAlert(true);
      });
    setLoading(true);
  }, [id, API_URL, API_VERSION]);

  return (
    <>
      <section className="userdoc_main">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />

        <Container>
          <Row className="justify-content-center">
            <Col md={6} className="mb-4">
              <Card>
                <Card.Body className="p-4">
                  <h4>{t("Edit Client")}</h4>
                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <label htmlFor="" className="form-label">
                          {t("Name")}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={name}
                          onChange={(event) => setName(event.target.value)}
                        />
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="mb-3">
                        <label htmlFor="" className="form-label">
                          {t("Email")}
                        </label>
                        <input
                          readOnly
                          disabled
                          type="text"
                          className="form-control"
                          id="email"
                          name="email"
                          value={email}
                        />
                      </div>
                    </Col>
                    <Col md={12} className="text-end">
                      <button
                        type="button"
                        value="UPDATE"
                        className="userbutton mt-3"
                        onClick={(e) => UpdateUser(e)}
                        disabled={loaderUpdate}
                      >
                        {loaderUpdate ? <BtnLoader /> : t("Update")}
                      </button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default EditClient;
